export default "__VITE_ASSET__Bx$18I5B__"